module.exports = __webpack_public_path__ + "img/google-play-button-3-x.6a419ba6.png";